import { render, staticRenderFns } from "./add-social-security-data.vue?vue&type=template&id=2a5e3738"
import script from "./add-social-security-data.vue?vue&type=script&lang=ts"
export * from "./add-social-security-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports